import type { ReactNode } from 'react';

interface MfaSetupCompleteNoticeProps {
  onContinue: () => void;
  /** 続行ボタンの前に置く操作（デスクトップアプリへ戻るリンクなど） */
  extraAction?: ReactNode;
  /** 続行ボタンの文言（既定は「続ける」） */
  continueLabel?: string;
}

/**
 * 認証アプリの登録完了の案内（要件 3.5）
 */
export function MfaSetupCompleteNotice({
  onContinue,
  continueLabel = '続ける',
  extraAction,
}: MfaSetupCompleteNoticeProps) {
  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-green-500/20 bg-green-500/10 p-4 space-y-2">
        <p className="text-sm font-medium text-foreground">認証アプリの登録が完了しました。</p>
        <p className="text-sm text-muted-foreground">
          次回からのサインインでは、パスワードに加えて認証アプリのコードを入力します。
        </p>
      </div>
      <p className="text-xs text-muted-foreground">
        スマートフォンの紛失や機種変更で認証アプリを使えなくなった場合は、管理者に MFA
        のリセットを依頼してください。
      </p>
      {extraAction}
      <button
        type="button"
        onClick={onContinue}
        className={
          extraAction
            ? 'w-full py-2 px-4 text-sm text-muted-foreground hover:text-foreground transition-colors'
            : 'w-full py-3 px-4 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-lg transition-colors'
        }
      >
        {continueLabel}
      </button>
    </div>
  );
}
